document.addEventListener("DOMContentLoaded", function() {
    const readMoreBtn = document.querySelector('.read-more');
    const productDescription = document.querySelector('.product-description');

    readMoreBtn.addEventListener('click', function() {
        // Expand to show full content
        productDescription.style.webkitLineClamp = 'unset';
        productDescription.style.maxHeight = 'none'; // Allow the content to expand fully
        readMoreBtn.style.display = 'none'; // Hide the "Read More" button after clicking
    });
});
